@import '../../vars.css';

.accent {
    color: var(--button-inverted-accent-color);
    background-color: var(--button-inverted-accent-base-bg-color);
    border: 1px solid transparent;

    @media (hover: hover) {
        &:hover {
            background-color: var(--button-inverted-accent-hover-bg-color);
        }
    }

    &:active {
        background-color: var(--button-inverted-accent-active-bg-color);
    }

    & > .loader {
        color: var(--button-spinner-inverted-static-color);
    }
}

.primary {
    border: 1px solid transparent;
}

.secondary {
    color: var(--button-inverted-secondary-color);
    border: 1px solid var(--button-inverted-secondary-base-border-color);

    & > .loader {
        color: var(--button-spinner-inverted-color);
    }

    &:not([disabled]) .hint {
        color: var(--button-inverted-secondary-hint-color);
    }
}

.outlined {
    color: var(--button-inverted-outlined-color);
    background-color: var(--button-inverted-outlined-base-bg-color);
    border: 1px solid var(--button-inverted-outlined-base-border-color);

    @media (hover: hover) {
        &:hover {
            background-color: var(--button-inverted-outlined-hover-bg-color);
            border-color: var(--button-inverted-outlined-hover-border-color);
        }
    }

    &:active {
        background-color: var(--button-inverted-outlined-active-bg-color);
    }

    & > .loader {
        color: var(--button-spinner-inverted-color);
    }

    &:not([disabled]) .hint {
        color: var(--button-inverted-outlined-hint-color);
    }
}

.transparent {
    color: var(--button-inverted-transparent-base-color);
    background-color: transparent;
    border: 1px solid transparent;

    @media (hover: hover) {
        &:hover {
            background-color: var(--button-inverted-transparent-hover-bg-color);
        }
    }

    &:active {
        background-color: var(--button-inverted-transparent-active-bg-color);
    }

    & > .loader {
        color: var(--button-spinner-inverted-color);
    }

    &:not([disabled]) .hint {
        color: var(--button-inverted-transparent-base-hint-color);
    }
}

.text {
    background-color: transparent;
    color: var(--button-inverted-text-base-color);

    @media (hover: hover) {
        &:hover {
            color: var(--button-inverted-text-hover-color);
        }
    }

    & > .loader {
        color: var(--button-spinner-inverted-color);
    }

    &:not([disabled]) .hint {
        color: var(--button-inverted-text-base-hint-color);
    }
}

.component[disabled] {
    &.accent {
        color: var(--button-inverted-accent-disabled-color);
        background-color: var(--button-inverted-accent-disabled-bg-color);

        &.loading {
            color: var(--button-inverted-accent-color);
            background-color: var(--button-inverted-accent-base-bg-color);
        }
    }

    &.secondary {
        border-color: var(--button-inverted-secondary-disabled-border-color);

        &.loading {
            color: var(--button-inverted-secondary-color);
            background-color: var(--button-inverted-secondary-base-bg-color);
            border-color: var(--button-inverted-secondary-base-border-color);
        }
    }

    &.outlined {
        background-color: var(--button-inverted-outlined-disabled-bg-color);

        &.loading {
            color: var(--button-inverted-outlined-color);
        }
    }

    &.transparent {
        background-color: transparent;

        &.loading {
            color: var(--button-inverted-transparent-base-color);
        }
    }

    &.text {
        &.loading {
            color: var(--button-inverted-text-base-color);
        }
    }
}
